import React, { useState } from 'react';
import withStyles from '@mui/styles/withStyles';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../reducers/authReducer';
import { history } from 'common/history';
import { acceptTermsAndCondition } from "../api/profile";
import { apiAction } from "actions/actionWrappers";
import { NavLink } from 'react-router-dom';
import Loader from './Loader';

const styles = () => ({
  popupOverlay: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  popupBox: {
    backgroundColor: '#ffffff',
    padding: 24,
    borderRadius: 16,
    maxWidth: 400,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
  },
  title: {
    margin: 0,
    marginBottom: 12,
    fontWeight: 600,
    fontSize: 18,
  },
  paragraph: {
    color: '#333',
    lineHeight: 1.5,
    marginBottom: 20,
    fontSize: 14,
  },
  link: {
    color: '#0B57D0',
    textDecoration: 'none',
    margin: '0 2px',
    cursor: 'pointer',
  },
  agreeButton: {
    backgroundColor: '#e0b334',
    color: '#fff',
    padding: '7px 25px',
    border: 'none',
    borderRadius: 999,
    fontWeight: 500,
    cursor: 'pointer',
    fontSize: 14,
    '&:hover': {
      backgroundColor: '#e0a72f',
    },
    '&:disabled': {
      backgroundColor: '#e0b334',
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  }
});

const TermsAndConditionPopup = ({ classes }) => {
  const dispatch = useDispatch();
  const { showPrivacyPolicyPopup } = useSelector(state => state.auth);
  const [loading, setLoading] = useState(false);

  if (!showPrivacyPolicyPopup) return null;

  const handleAccept = async () => {
    setLoading(true);
    try {
      await dispatch(apiAction(acceptTermsAndCondition));
      dispatch({ type: actions.HIDE_PRIVACY_POLICY_POPUP });
      history.push("/learninghub");
    } catch (error) {
      console.error("Failed to update agreement:", error);
      alert("Something went wrong while saving your response. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Loader visible={loading} />
      <div className={classes.popupOverlay}>
        <div className={classes.popupBox}>
          <h3 className={classes.title}>Terms and Privacy Policy</h3>
          <p className={classes.paragraph}>
            We've updated our
            <NavLink to="/privacypolicy" className={classes.link} target="_blank" rel="noopener noreferrer">Privacy Policy</NavLink>,
            <NavLink to="/termsofservice" className={classes.link} target="_blank" rel="noopener noreferrer">Terms of Service</NavLink> &
            <NavLink to="/codeofconduct" className={classes.link} target="_blank" rel="noopener noreferrer">Code of Conduct</NavLink>.
            Please review the changes and click <strong>'CONTINUE'</strong> to proceed.
          </p>
          <button
            onClick={handleAccept}
            className={classes.agreeButton}
            disabled={loading}
          >
            {loading ? 'Processing...' : 'CONTINUE'}
          </button>
        </div>
      </div>
    </>
  );
};

export default withStyles(styles)(TermsAndConditionPopup);
